import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Header from '../Components/Heading';
import TextInput from '../Components/TextInput';
import Button from '../Components/Button';
import * as KayakingGeoService from '../Services/KayakingGeoService';
import { useParams } from 'react-router-dom';
import ReactRTE from '../Components/ReactRTE';


function Wrapper({ location }) {
	const transformAtoB = (l) => {
		const { coordinates, features, ...rest } = l;
		// alert(features.join(", "));
		return {
			...rest,
			lon: coordinates.lon,
			lat: coordinates.lat,
			features: features.join(", ")
		}
	}
	const transformBtoA = (l) => {
		const { lon, lat, features, ...rest } = l;

		return {
			...rest,
			coordinates: { lon, lat },
			features: features.split(", ")
		}
	}
	const formik = useFormik({
		initialValues: transformAtoB(location),
		validationSchema,
		onSubmit: (values, { resetForm }) => {
			const resulting = transformBtoA(values);
			setEnable(false);
			KayakingGeoService.updateLocation(resulting).then((a) => {
				setEnable(true);
				window.location.reload();
			}).catch(e => {
				setEnable(true);
				alert(e)
			});
		}
	});


	const [enable, setEnable] = useState(true);


	return (
		<div className="grid justify-items-center">
			<Header text="Create Featured Paragraph Snippet" type="h2" />
			< form className="w-4/5">
				<TextInput
					label="Location Slug"
					placeholder="Location Slug"
					name="locationSlug"
					onChange={formik.handleChange}
					value={formik.values.locationSlug}
					disabled={true}
					error={formik.errors.locationSlug}
				/>
				<TextInput
					label="Name"
					placeholder="Name"
					name="name"
					onChange={formik.handleChange}
					value={formik.values.name}
					disabled={!enable}
					error={formik.errors.name}
				/>
				<TextInput
					label="Water Body"
					placeholder="Water Body"
					name="waterBody"
					onChange={formik.handleChange}
					value={formik.values.waterBody}
					disabled={!enable}
					error={formik.errors.waterBody}
				/>

				<TextInput
					label="Features"
					placeholder="Features"
					name="features"
					onChange={formik.handleChange}
					value={formik.values.features}
					disabled={!enable}
					error={formik.errors.features}
				/>

				<TextInput
					label="Longtiude"
					placeholder="Longtiude"
					name="lon"
					onChange={formik.handleChange}
					value={formik.values.lon}
					disabled={!enable}
					error={formik.errors.lon}
				/>
				<TextInput
					label="Latitude"
					placeholder="Latitude"
					name="lat"
					onChange={formik.handleChange}
					value={formik.values.lat}
					disabled={!enable}
					error={formik.errors.lat}
				/>
				<label className="w-full form-label font-bold inline-block mt-2 text-gray-700">Body</label>
				<ReactRTE value={formik.values.body} setValue={formik.setFieldValue} name="body" id="body" />
				<Button text="Submit" disabled={!enable} type="submit" onClick={formik.handleSubmit} />
			</form>
		</div >
	);
}

function processSubmit(setEnable, values, setRes, resetForm) {
	setEnable(false);
}

const validationSchema = Yup.object().shape({
	locationSlug: Yup.string().required('Required'),
	name: Yup.string().required('Required'),
	waterBody: Yup.string().nullable(),
	lon: Yup.number().required('Required'),
	lat: Yup.number().required('Required'),
	features: Yup.string().required('Required'),
	body: Yup.string().nullable()
});


export default function UpdateKayakingGeo() {

	const [location, setLocation] = useState(null);

	const { id } = useParams();

	useEffect(() => {
		KayakingGeoService.getLocation(id.replace("kayaking-at-", "")).then((a) => {
			setLocation(a);
		});
	}, []);

	return (
		<>
			{location && <Wrapper location={location} />}
		</>
	)
}